
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';

import { Portal } from '@/modules/common/components/Portal';
import { CloseButton } from '@/modules/common/components/buttons';
import {
  NavBar,
  Heading,
  BankAccount,
  BaseModal
} from '@warrenbrasil/nebraska-web';
import { CashBankAccount } from '@/modules/common/services/graphql/server/server.sdk';
import { RouteMixin } from '@/modules/common/mixins/route';
import { BankAccountField } from './types';
import * as trackDepositEvents from './track-deposit-events';

@Component({
  components: {
    BaseModal,
    CloseButton,
    NavBar,
    Heading,
    BankAccount,
    Portal
  }
})
export default class HomeCashDepositModal extends Mixins(RouteMixin) {
  @Prop({ type: Object, required: true })
  readonly bankAccount!: CashBankAccount;

  @Prop({ type: Boolean, required: true })
  readonly open!: boolean;

  @Prop({ type: String, required: true })
  readonly cashAccountId!: string;

  @Watch('open', { immediate: true })
  openModalWatcher(isOpen: boolean) {
    if (!isOpen) return;
    trackDepositEvents.trackDepositModalOpening();
  }

  handleClose() {
    this.$emit('close');
  }

  onCopyBankAccountData(_value: string, field: BankAccountField) {
    trackDepositEvents.trackDepositByTED(field);
  }
}
